import { ImageKeyUploadField } from "@/shared/ui/ImageKeyUploadField";

export const ANNOUNCEMENT_IMAGE_KEY_PREFIX = "uploads/announcements";

export type AnnouncementImageUploadFieldProps = {
  value: string;
  onChange: (key: string) => void;
  pendingFile: File | null;
  onFileSelect: (file: File | null) => void;
  disabled?: boolean;
  label?: string;
};

export function AnnouncementImageUploadField({
  value,
  onChange,
  pendingFile,
  onFileSelect,
  disabled,
  label = "ຮູບຂ່າວສານ",
}: AnnouncementImageUploadFieldProps) {
  return (
    <ImageKeyUploadField
      value={value}
      onChange={onChange}
      keyPrefix={ANNOUNCEMENT_IMAGE_KEY_PREFIX}
      label={label}
      deferUpload
      pendingFile={pendingFile}
      onFileSelect={(file) => onFileSelect(file ?? null)}
      onClear={() => {
        onFileSelect(null);
        onChange("");
      }}
      disabled={disabled}
      aspectRatio="aspect-4/3"
      aspectHint="4:3"
      widthPx={640}
      heightPx={480}
      className="w-full max-w-xl"
    />
  );
}
